<template>
    <div v-if="errorMessage == null" class="d-flex align-center justify-center" style="height: 100vh">
        <v-progress-circular indeterminate color="primary" size="64" />
    </div>
    <div v-else>
        {{ errorMessage }}
        <p>
            redirect button to login again.
        </p>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useOrganizationStore } from '@/store/organizationStore';
import { useAuth0 } from '@auth0/auth0-vue';
import OrganizationService from '@/services/OrganizationService'
import DualloUserService from '@/services/DualloUserService';
import AuthZeroService from '@/services/AuthZeroService';

const router = useRouter()
const organizationStore = useOrganizationStore()
const {  isAuthenticated, user } = useAuth0()
const organization = ref(null);
const authZeroOrg = ref(null);

let errorMessage = ref(null)

onMounted(async () => {
    try {
        if (!isAuthenticated.value) return;
        if (user.value) {            
            const organizationId = user.value.org_id;
            organizationStore.setAuthZeroOrgId(organizationId);

            await setOrganizationAsync(organizationId);

            await redirectUser(organization.value.id, user.value.sub);
        }
    } finally {
        console.log("Loading complete.");
    }
})

async function setOrganizationAsync(organizationId) {
    organization.value = await OrganizationService.getOrganizationByAuthZeroOrgId(organizationId);
    authZeroOrg.value = await AuthZeroService.getOrganizationById(organizationId);

    organizationStore.setOrganizationId(organization.value.id);
    organizationStore.setOrganizationSubscriptionActive(organization.value.subscriptionActive);
    organizationStore.setOrganizationLogoUrl(authZeroOrg.value.logoUrl);
}

function redirectHome() {
    router.push('/assets');
}

function redirectToTermsOfService() {
    router.push('/tos');
}

async function redirectUser(organizationId, userId) {
    const userService = new DualloUserService();
    const userProfile = await userService.getUserProfileAsync(organizationId, userId);

    if (userProfile == null) {
        errorMessage.value = "No user profile found. Contact support@duallo.ai for assistance.";
        return false;
    } else if (!userProfile.acceptedTermsOfService) {
        redirectToTermsOfService();
    } else {
        await GenerateSaSToken(organizationId, userId);
        redirectHome();
    }
}

async function GenerateSaSToken(organizationId, userId) {
    const userService = new DualloUserService();
    await userService.generateSasToken(organizationId, userId);
}

</script>
